import React from 'react';

export const ConfigurationContext = React.createContext({
    data: {
        company: {},
        category: {}
    },
    setData: (data) => { }
});

export const ThemeProvider = ConfigurationContext.Provider;
export const ThemeConsumer = ConfigurationContext.Consumer;